(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.handleLoad = this.handleLoad.bind(this);
      this.handleResize = this.handleResize.bind(this);
      window.addEventListener('load', this.handleLoad);
      window.addEventListener('resize', this.handleResize);
      this.searchButtonText = document.querySelectorAll('span.header__icon--search-text');
      this.searchBelow = document.querySelector('.header-search-below');
      this.animatedText();
      this.headerMultiTierNavigation = this.querySelector('.header__inline-multi-tier-menu');
      this.closeButton = this.querySelectorAll('.menu-drawer__close-button');
      if (this.headerMultiTierNavigation){
        this.multiTierNav();
      }
      this.drawerNoMenu();
      this.drawerCloseMenu();
    }

    connectedCallback() {
      const bodyLock = document.querySelector('body');
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerUnstuck = this.getAttribute('data-sticky-type') === 'none';
      this.headerBounds = {};
      this.headerSearchOverlay = document.querySelector(".header-search-below--overlay");
      if (this.headerSearchOverlay) {
        this.headerSearchOverlay.addEventListener("click", this.handleSearchOverlayClick.bind(this));
      }

      this.mobileMenuButton = document.querySelectorAll('.header__icon--menu');
      if (this.mobileMenuButton){
        this.mobileMenuButton.forEach((event) => {
          event.addEventListener("click", this.mobileMenuSearchClose.bind(this));
        });
      }

      this.cartDrawerButton = document.querySelectorAll('.header__icon--cart');
      this.cartDrawerButton.forEach((event) => {
        event.addEventListener("click", this.cartDrawerSearchClose.bind(this));
      });

      this.setHeaderHeight();

      window.matchMedia('(max-width: 1024px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      if(this.headerUnstuck) {
        this.header.classList.add('shopify-section-header-unstuck');
      } 

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.searchDetails = this.querySelector("details-modal.header__search");
      this.drawer = this.querySelector("header-drawer");

      this.searchSummaryToggles = this.querySelectorAll('.header__icon--search');
      this.searchSummaryToggles.forEach((toggle) => {
        toggle.addEventListener('click', this.onSummaryClick.bind(this));
      });

      this.drawerSummaryToggles = this.querySelectorAll('.header__icon--menu');
      this.drawerSummaryToggles.forEach((toggle) => {
        toggle.addEventListener('click', this.onDrawerClick.bind(this));
      });

      this.searchModalClose = this.querySelectorAll('.search-modal__close-button');
      this.searchModalClose.forEach((button) => {
        button.addEventListener("click", function() {
          bodyLock.classList.remove('overflow-hidden-tablet'); 
        });
      }) 

      this.closeButton.forEach((button) => {
        button.addEventListener("click", function() {
          bodyLock.classList.add('overflow-hidden-tablet'); 
        });
      })

      /* Mega Menu + All type hover */ 
      this.megaMenuMenus = this.querySelectorAll("header-menu");
      this.megaMenuDetails = this.querySelectorAll(".mega-menu");
      this.debouncedMMDetailsToggle = debounce((event) => {
          this.onMMDetailsToggle(event);
      }, 200);
      this.megaMenuDetails.forEach((details) => {
          details.addEventListener('toggle', this.onMMDetailsToggle.bind(this));
      })
      this.megaMenuMenus.forEach((menu) => {
        this.hover(menu, e => {
          // On hover
          menu.querySelector("details").setAttribute("open", "");
          menu.querySelector("details > summary").setAttribute("aria-expanded", "true");
        }, throttle(e => {
          // On hover leave
          menu.querySelector("details").removeAttribute("open", "");
          menu.querySelector("details > summary").setAttribute("aria-expanded", "false");
        }), 100);
      });

      this.createObserver();
    }

     multiTierNav(item){
      const multiTierNavigation = this.headerMultiTierNavigation;
      multiTierNavigation.classList.remove('hidden');
      const multiTierParent = this.querySelectorAll('.header__multi-tier-parent');
      multiTierParent.forEach((item) => {
        const multiTierParentLinkIcon = item.querySelector('.multi-tier__link-icon');
        const multiTierParentNav = item.querySelector('.header__multi-tier-parent .header__inline');
        if (!item.contains(multiTierParentNav)) {
          multiTierParentLinkIcon.remove();
        }
        item.addEventListener('keydown', event => {
          if (event.key === 'Enter') {
            item.classList.toggle('tabbed');
            if (multiTierParentNav) {
              if (item.classList.contains('tabbed')){
                multiTierParentNav.classList.add('open-tab');
              } else {
                multiTierParentNav.classList.remove('open-tab');
              }
            }
          }
          if (item.classList.contains('tabbed')) {
            multiTierParentNav.addEventListener('keydown', event => {
              if (event.key === 'Enter') {
                event.stopPropagation();
              }
            });
          }
        });
      });
    }

    drawerNoMenu() {
      this.drawerToggleButton = this.querySelectorAll('.header__icon--menu');
      this.drawerNoInnerMenu = this.querySelectorAll(".no-child-detail .child-link-details");
      this.drawerToggleButton.forEach(button => {
        button.addEventListener("click", event => {
          this.drawerNoInnerMenu.forEach((element) => {
            element.classList.add("menu-opening");
            element.setAttribute('open', '');
          });
        });
      });
    }

    drawerCloseMenu() {
      this.mainBodyOverlay = document.querySelector('body');
      this.searchInline = document.querySelector('.header-search');
      this.headerSearchButton = this.querySelectorAll(".header__icon--search");
      this.drawerMenuContainer = this.querySelector('.menu-drawer-container');
      this.headerMenuButton = this.querySelectorAll('.header__icon--menu');
      this.headerSearchButton.forEach(button => {
        button.addEventListener("click", event => {
          this.headerMenuButton.forEach(button => {
            button.setAttribute('aria-expanded', 'false');
          });
          button.classList.toggle('active');
          if(this.searchInline){
            this.searchInline.classList.toggle('active');
          }
          if(button.classList.contains('active')){
            this.mainBodyOverlay.classList.add('overflow-hidden-tablet');
          } else {
            this.mainBodyOverlay.classList.remove('overflow-hidden-tablet');
          }
          this.drawerMenuContainer.classList.remove("menu-opening");
          this.drawerMenuContainer.removeAttribute('open', '');
        });
      });
    } 
    
    animatedText() {
      const iconAnimatedSearchIcon = this.querySelectorAll('.header__icon--search.bar');
      iconAnimatedSearchIcon.forEach(function(event) {
        const iconAnimatedSearchIconSpan = event.querySelector('span.header__icon--search-text');
        const iconAnimatedStyle = event.dataset.search_style;
        const iconAnimatedText = event.dataset.search_text;
        const iconAnimatedArray = iconAnimatedText.split('\n');
        const iconModifiedArray = iconAnimatedArray.map(item => {return item});
        event.addEventListener("click", () => {
          iconAnimatedSearchIconSpan.classList.toggle("hidden");
        });
        if (iconModifiedArray.length > 1 && iconAnimatedStyle !== 'none'){
          let iconAnimatedIndex = 0;
          let iconAnimatedCharIndex = 0;
          let iconAnimatedDelete = false;
          if (iconAnimatedStyle == 'fade') {
            // Fade In Words
            iconAnimatedSearchIconSpan.classList.remove('typed');
            function iconShowNextWord() {
              if (iconAnimatedIndex < iconModifiedArray.length) {
                iconAnimatedSearchIconSpan.textContent = iconModifiedArray[iconAnimatedIndex];
                iconAnimatedSearchIconSpan.style.transition = "opacity 0.5s ease-in-out";
                iconAnimatedSearchIconSpan.style.opacity = '1'; // Show the word
                setTimeout(() => {
                    iconAnimatedSearchIconSpan.style.opacity = '0'; // Hide the word
                    iconAnimatedIndex++;
                    setTimeout(iconShowNextWord, 1000); // Call recursively for the next word after a delay
                }, 2000);
              } else {
                iconAnimatedIndex = 0; // Loop back
                setTimeout(iconShowNextWord, 300);
              }
            } iconShowNextWord();
          } else {
            // Typed
            iconAnimatedSearchIconSpan.classList.add('typed');
            function iconTypedWord() {
              const iconCurrentWord = iconModifiedArray[iconAnimatedIndex % iconModifiedArray.length];
              if (iconAnimatedDelete) {
                iconAnimatedSearchIconSpan.textContent = iconCurrentWord.substring(0, iconAnimatedCharIndex - 1);
                iconAnimatedCharIndex--;
              } else {
                iconAnimatedSearchIconSpan.textContent = iconCurrentWord.substring(0, iconAnimatedCharIndex + 1);
                iconAnimatedCharIndex++;
              }
              let iconTypeSpeed = 300; // Type Speed
              if (iconAnimatedDelete) {
                iconTypeSpeed /= 4; // Delete
              }
              // Fully Typed
              if (!iconAnimatedDelete && iconAnimatedCharIndex === iconCurrentWord.length) {
                iconTypeSpeed = 500; // Pause between words
                iconAnimatedDelete = true;
              } else if (iconAnimatedDelete && iconAnimatedCharIndex === 0){
                iconAnimatedDelete = false;
                iconAnimatedIndex++;
                iconTypeSpeed = 500; // Pause between cycle
              }
              setTimeout(iconTypedWord, iconTypeSpeed);
            } iconTypedWord();
          }
        } else {
          iconAnimatedSearchIconSpan.classList.remove('typed');
          iconAnimatedSearchIconSpan.innerHTML = iconAnimatedArray[0];
        }
      });
    }

    onMMDetailsToggle(event) {
      if (event && event.newState == 'open') {
      let menuItems = event.target.querySelectorAll(".mega-menu__list .grandchild-list");
        menuItems.forEach((menuItem) => {
          let height = 0;
          let linkItems = menuItem.children;
          if (typeof linkItems !== 'undefined' && linkItems.length > 10) {
            for (let i = 0; i <= 10; i++) {
              let itemStyles = window.getComputedStyle(linkItems[i].firstElementChild);
              let itemPadding = parseFloat(itemStyles.paddingTop) + parseFloat(itemStyles.paddingBottom);
              let itemHeight = linkItems[i].firstElementChild.offsetHeight;
              height += itemHeight;
            }
            menuItem.style.maxHeight = (height + 5) + "px";
          }
          
        });
      }
    } 

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    hover(element, enter, leave){
      element.addEventListener('mouseenter', enter)
      element.addEventListener('mouseleave', leave)
    }

    handleSearchOverlayClick() {
      this.searchButtonText.forEach(button => {
        button.classList.remove('hidden');
      });
      if(this.searchBelow){
        this.searchBelow.classList.remove('active');
        this.searchBelow.setAttribute("inert", "");
      }
    } 

    cartDrawerSearchClose() {
      this.searchButtonText.forEach(button => {
        if(button.classList.contains('hidden')){
          button.classList.remove('hidden');
        }
      });
      if(this.searchBelow){
        if(this.searchBelow.classList.contains('active')){
          this.searchBelow.classList.remove('active');
          this.searchBelow.setAttribute("inert", "");
        }
      }
    }

    mobileMenuSearchClose() {
      const searchButtonStatus = document.querySelectorAll('.header__icon--search');
      if(this.searchBelow){
        if(this.searchBelow.classList.contains('active')){
          this.searchBelow.classList.remove('active');
          this.searchBelow.setAttribute("inert", "");
        }
      }
      searchButtonStatus.forEach(button => {
        if(button.classList.contains('active')){
          button.classList.remove('active');
        }
      });
    }

    onSummaryClick(event) {
      event.preventDefault();
      if (this.searchDetails) {
        this.searchDetails.onSummaryClick(event);
      }
      if(this.searchBelow){
        this.searchBelow.toggleAttribute("inert");
        if (this.searchBelow.classList.contains("searchanise")){
          if (window.innerWidth > 768){
            this.searchBelow.classList.toggle("active");
          }
        }
      }
    }

    onDrawerClick(event) {
      this.drawer.onSummaryClick(event);
    }

    handleLoad() {
      if (window.innerWidth < 768){
        if(this.searchBelow){
          if (this.searchBelow.classList.contains("default-mobile")){
            this.searchBelow.removeAttribute("inert");
          }
          if(this.searchBelow.classList.contains('inline-search')){
            if(this.searchBelow.classList.contains('toggle-search')){
              this.searchBelow.setAttribute("inert", "");
            } else {
              this.searchBelow.removeAttribute("inert");
            }
          }
        }
      }
    }

    handleResize() {
      if (window.innerWidth < 768){
        if(this.searchBelow){
          if (this.searchBelow.classList.contains('default-mobile')){
            this.searchBelow.removeAttribute("inert");
          }
          if(this.searchBelow.classList.contains('inline-search')){
            if(this.searchBelow.classList.contains('toggle-search')){
              this.searchBelow.setAttribute("inert", "");
            } else {
              this.searchBelow.removeAttribute("inert");
            }
          }
        } else {
          if (this.searchBelow.classList.contains("default-mobile")){
            this.searchBelow.setAttribute("inert", "");
          }
          if (this.searchBelow.classList.contains("searchanise")){
            this.searchBelow.classList.remove("active");
          }
        }
      }
    } 

    destroy() {
      window.removeEventListener('load', this.handleLoad);
      window.removeEventListener('resize', this.handleResize);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);

      let resizeObserver = new ResizeObserver((entries, observer) => {
          if (typeof this.megaMenuDetails !== 'undefined') {
            this.megaMenuDetails.forEach((details) => {
              this.onMMDetailsToggle();
            });
          }
      });

      resizeObserver.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if(!this.headerUnstuck) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          this.header.classList.remove('scrolled-past-header');
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }

  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
